(ns practitest.frontend.common.tooltip
  (:require
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components.tooltip :as tooltip]))

(defn info-circle-tooltip
  [tooltip-body]
  [tooltip/mux-tooltip
   {:trigger "click"}
   tooltip-body
   (fn [props]
     [:span.icon-holder.clickable
      props
      [icons/mux-info-circle]])])